// extracted by mini-css-extract-plugin
export default {"container":"contact_container__lyacK","linkBox":"contact_linkBox__fJLEd","linksBox":"contact_linksBox__D3fNO"};